import React, { FC } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { getLoginRedirectLocation } from './redirectAfterLogin';

const RedirectToLogin: FC = () => {
  const location = useLocation();

  return <Redirect to={getLoginRedirectLocation(location)} />;
};

export default RedirectToLogin;
